import LocalesMenu from "./LocalesMenu";

export default LocalesMenu;
